export default __webpack_public_path__ + "static/media/signin-background-three.cf0d00fa.jpg";